import React from 'react';
import './WelcomeSection.css';
import { Link } from "react-router-dom";

const WelcomeSection = () => {
  return (
    <div className="welcome-section">
      <h2>🎉 Congratulations! Your exclusive discounts await.</h2>
      <p className="subtext">Start exploring handpicked deals just for you. You're now part of India's smart saver community!</p>

      <div className="actions">
        <Link to="/deals">
          <button className="explore-btn">Explore My Discounts</button>
        </Link>
        <div className="referral-box">
          <p><strong>Invite friends, earn bonus rewards!</strong></p>
          <p>Share your referral link and get ₹100 bonus for every friend who joins.</p>
          <button className="referral-btn">Share Referral Link</button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;
